/* ==========================================================================
   SearcherFli > Constants
   ========================================================================== */
const { formatDate } = require('@bluekiri/alexandria/helpers/dataHelpers');

const { ROUNDTRIP } = require('../client/js/product/constants');

const ORIGIN_DEFAULT_TYPES = ['AER'];

const DESTINATION_DEFAULT_TYPES = ['AER'];

const PRODUCT_DEFAULT_VALUE = ROUNDTRIP;

const CALENDAR_DEFAULT_START_DATE = formatDate(new Date(new Date().getTime() + 1000 * 60 * 60 * 24));
const CALENDAR_DEFAULT_END_DATE = formatDate(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 3));
const CALENDAR_DEFAULT_MIN_DATE = formatDate(new Date(new Date().getTime()));
const CALENDAR_DEFAULT_MAX_DATE = formatDate(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 730));

const ADULTS_DEFAULT_VALUE = 1;
const ADULTS_MIN_VALUE = 1;
const ADULTS_MAX_VALUE = 9;

const CHILDREN_DEFAULT_VALUE = 0;
const CHILDREN_MIN_VALUE = 0;
const CHILDREN_MAX_VALUE = 9;

const BABIES_DEFAULT_VALUE = 0;
const BABIES_MIN_VALUE = 0;
const BABIES_MAX_VALUE = 9;

const URL_DEFAULT_VALUE = '/transportstransactional/AvailabilityMaterial';

/* Exports */
module.exports = {
    PRODUCT_DEFAULT_VALUE,
    ORIGIN: {
        ORIGIN_DEFAULT_TYPES
    },
    DESTINATION: {
        DESTINATION_DEFAULT_TYPES
    },
    CALENDAR: {
        CALENDAR_DEFAULT_END_DATE,
        CALENDAR_DEFAULT_START_DATE,
        CALENDAR_DEFAULT_MIN_DATE,
        CALENDAR_DEFAULT_MAX_DATE
    },
    PASSENGERS: {
        ADULTS: {
            ADULTS_DEFAULT_VALUE,
            ADULTS_MAX_VALUE,
            ADULTS_MIN_VALUE
        },
        CHILDREN: {
            CHILDREN_DEFAULT_VALUE,
            CHILDREN_MAX_VALUE,
            CHILDREN_MIN_VALUE
        },
        BABIES: {
            BABIES_DEFAULT_VALUE,
            BABIES_MAX_VALUE,
            BABIES_MIN_VALUE
        }
    },
    URL: {
        URL_DEFAULT_VALUE
    }
};
